// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11DRU","newExpiryDate":"styles_newExpiryDate__15YjI","footer":"styles_footer__eN-9f"};